import Caver from 'caver-js'

const caver = new Caver(window.klaytn)

export default caver
